import {negativeSvg as Icon__small__negativeSvg} from '../Icon__small/Icon__small--negative.js';

export var negative = {
  name: 'negative',
  category: 'icon',
  colorable: true,
  svg: Icon__small__negativeSvg,
};
